var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "单据编号",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入单据编号" },
                                    model: {
                                      value: _vm.queryParam.number,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "number", $$v)
                                      },
                                      expression: "queryParam.number",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "商品信息",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder:
                                        "请输入条码、名称、助记码、规格、型号等信息",
                                    },
                                    model: {
                                      value: _vm.queryParam.materialParam,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "materialParam",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.materialParam",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "单据日期",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-range-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      format: "YYYY-MM-DD",
                                      placeholder: ["开始时间", "结束时间"],
                                    },
                                    on: {
                                      change: _vm.onDateChange,
                                      ok: _vm.onDateOk,
                                    },
                                    model: {
                                      value: _vm.queryParam.createTimeRange,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.queryParam,
                                          "createTimeRange",
                                          $$v
                                        )
                                      },
                                      expression: "queryParam.createTimeRange",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 6, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.handleToggleSearch },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.toggleSearchStatus
                                              ? "收起"
                                              : "展开"
                                          ) +
                                          "\n                  "
                                      ),
                                      _c("a-icon", {
                                        attrs: {
                                          type: _vm.toggleSearchStatus
                                            ? "up"
                                            : "down",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.toggleSearchStatus
                        ? [
                            _c(
                              "a-row",
                              { attrs: { gutter: 24 } },
                              [
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "客户",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择客户",
                                              showSearch: "",
                                              "allow-clear": "",
                                              optionFilterProp: "children",
                                            },
                                            on: {
                                              search: _vm.handleSearchCustomer,
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "dropdownRender",
                                                  fn: function (menu) {
                                                    return _c(
                                                      "div",
                                                      {},
                                                      [
                                                        _c("v-nodes", {
                                                          attrs: {
                                                            vnodes: menu,
                                                          },
                                                        }),
                                                        _c("a-divider", {
                                                          staticStyle: {
                                                            margin: "4px 0",
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "dropdown-btn",
                                                            on: {
                                                              mousedown: (e) =>
                                                                e.preventDefault(),
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.initCustomer(
                                                                  0
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("a-icon", {
                                                              attrs: {
                                                                type: "reload",
                                                              },
                                                            }),
                                                            _vm._v(" 刷新列表"),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              1709331955
                                            ),
                                            model: {
                                              value: _vm.queryParam.organId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "organId",
                                                  $$v
                                                )
                                              },
                                              expression: "queryParam.organId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.cusList,
                                            function (item, index) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: index,
                                                  attrs: { value: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.supplier) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "仓库名称",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择仓库",
                                              showSearch: "",
                                              "allow-clear": "",
                                              optionFilterProp: "children",
                                            },
                                            model: {
                                              value: _vm.queryParam.depotId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "depotId",
                                                  $$v
                                                )
                                              },
                                              expression: "queryParam.depotId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.depotList,
                                            function (depot, index) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: index,
                                                  attrs: { value: depot.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(depot.depotName) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "操作员",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择操作员",
                                              showSearch: "",
                                              "allow-clear": "",
                                              optionFilterProp: "children",
                                            },
                                            model: {
                                              value: _vm.queryParam.creator,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "creator",
                                                  $$v
                                                )
                                              },
                                              expression: "queryParam.creator",
                                            },
                                          },
                                          _vm._l(
                                            _vm.userList,
                                            function (item, index) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: index,
                                                  attrs: { value: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.userName) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "关联订单",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入关联订单",
                                          },
                                          model: {
                                            value: _vm.queryParam.linkNumber,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "linkNumber",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.linkNumber",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "结算账户",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择结算账户",
                                              showSearch: "",
                                              "allow-clear": "",
                                              optionFilterProp: "children",
                                            },
                                            model: {
                                              value: _vm.queryParam.accountId,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "accountId",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryParam.accountId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.accountList,
                                            function (item, index) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: index,
                                                  attrs: { value: item.id },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.name) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "本次欠款",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择有无本次欠款",
                                              "allow-clear": "",
                                            },
                                            model: {
                                              value: _vm.queryParam.hasDebt,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "hasDebt",
                                                  $$v
                                                )
                                              },
                                              expression: "queryParam.hasDebt",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "1" } },
                                              [_vm._v("有欠款")]
                                            ),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "0" } },
                                              [_vm._v("无欠款")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "最终欠款",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择有无最终欠款",
                                              "allow-clear": "",
                                            },
                                            model: {
                                              value: _vm.queryParam.hasLastDebt,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "hasLastDebt",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "queryParam.hasLastDebt",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "1" } },
                                              [_vm._v("有欠款")]
                                            ),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "0" } },
                                              [_vm._v("无欠款")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "单据状态",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择单据状态",
                                              "allow-clear": "",
                                            },
                                            model: {
                                              value: _vm.queryParam.status,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "queryParam.status",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "0" } },
                                              [_vm._v("未审核")]
                                            ),
                                            !_vm.checkFlag
                                              ? _c(
                                                  "a-select-option",
                                                  { attrs: { value: "9" } },
                                                  [_vm._v("审核中")]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "1" } },
                                              [_vm._v("已审核")]
                                            ),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "3" } },
                                              [_vm._v("部分出库")]
                                            ),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "2" } },
                                              [_vm._v("完成出库")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "销售人员",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            attrs: {
                                              placeholder: "请选择销售人员",
                                              showSearch: "",
                                              "allow-clear": "",
                                              optionFilterProp: "children",
                                            },
                                            model: {
                                              value: _vm.queryParam.salesMan,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.queryParam,
                                                  "salesMan",
                                                  $$v
                                                )
                                              },
                                              expression: "queryParam.salesMan",
                                            },
                                          },
                                          _vm._l(
                                            _vm.salesManList,
                                            function (item, index) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: index,
                                                  attrs: { value: item.value },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(item.text) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "a-col",
                                  { attrs: { md: 6, sm: 24 } },
                                  [
                                    _c(
                                      "a-form-item",
                                      {
                                        attrs: {
                                          label: "单据备注",
                                          labelCol: _vm.labelCol,
                                          wrapperCol: _vm.wrapperCol,
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            placeholder: "请输入单据备注",
                                          },
                                          model: {
                                            value: _vm.queryParam.remark,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryParam,
                                                "remark",
                                                $$v
                                              )
                                            },
                                            expression: "queryParam.remark",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.myHandleAdd },
                        },
                        [_vm._v("新增")]
                      )
                    : _vm._e(),
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "delete" },
                          on: { click: _vm.batchDel },
                        },
                        [_vm._v("删除")]
                      )
                    : _vm._e(),
                  _vm.quickBtn.saleBack.indexOf(1) > -1 &&
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "share-alt" },
                          on: {
                            click: function ($event) {
                              return _vm.transferBill(
                                "转销售退货",
                                _vm.quickBtn.saleBack
                              )
                            },
                          },
                        },
                        [_vm._v("转销售退货")]
                      )
                    : _vm._e(),
                  _c(
                    "a-tooltip",
                    { attrs: { title: "可将状态是部分出库的单据强制完成" } },
                    [
                      _vm.inOutManageFlag && _vm.btnEnableList.indexOf(1) > -1
                        ? _c(
                            "a-button",
                            {
                              attrs: { icon: "issues-close" },
                              on: { click: _vm.batchForceClose },
                            },
                            [_vm._v("强制结单")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.checkFlag && _vm.btnEnableList.indexOf(2) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "check" },
                          on: {
                            click: function ($event) {
                              return _vm.batchSetStatus(1)
                            },
                          },
                        },
                        [_vm._v("审核")]
                      )
                    : _vm._e(),
                  _vm.checkFlag && _vm.btnEnableList.indexOf(7) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "stop" },
                          on: {
                            click: function ($event) {
                              return _vm.batchSetStatus(0)
                            },
                          },
                        },
                        [_vm._v("反审核")]
                      )
                    : _vm._e(),
                  _c(
                    "a-tooltip",
                    { attrs: { title: "可对最终欠款的值进行修正" } },
                    [
                      _vm.btnEnableList.indexOf(1) > -1
                        ? _c(
                            "a-button",
                            {
                              attrs: { icon: "fund" },
                              on: { click: _vm.batchSetLastDebt },
                            },
                            [_vm._v("修正欠款")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.isShowExcel && _vm.btnEnableList.indexOf(3) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { icon: "download" },
                          on: { click: _vm.handleExport },
                        },
                        [_vm._v("导出")]
                      )
                    : _vm._e(),
                  _c(
                    "a-popover",
                    { attrs: { trigger: "click", placement: "right" } },
                    [
                      _c(
                        "template",
                        { slot: "content" },
                        [
                          _c(
                            "a-checkbox-group",
                            {
                              attrs: { defaultValue: _vm.settingDataIndex },
                              on: { change: _vm.onColChange },
                              model: {
                                value: _vm.settingDataIndex,
                                callback: function ($$v) {
                                  _vm.settingDataIndex = $$v
                                },
                                expression: "settingDataIndex",
                              },
                            },
                            [
                              _c(
                                "a-row",
                                { staticStyle: { width: "500px" } },
                                [
                                  _vm._l(
                                    _vm.defColumns,
                                    function (item, index) {
                                      return [
                                        [
                                          _c(
                                            "a-col",
                                            { attrs: { span: 8 } },
                                            [
                                              _c(
                                                "a-checkbox",
                                                {
                                                  attrs: {
                                                    value: item.dataIndex,
                                                  },
                                                },
                                                [
                                                  _c("j-ellipsis", {
                                                    attrs: {
                                                      value: item.title,
                                                      length: 10,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "a-row",
                                { staticStyle: { "padding-top": "10px" } },
                                [
                                  _c(
                                    "a-col",
                                    [
                                      _vm._v(
                                        "\n                  恢复默认列配置："
                                      ),
                                      _c(
                                        "a-button",
                                        {
                                          attrs: {
                                            type: "link",
                                            size: "small",
                                          },
                                          on: { click: _vm.handleRestDefault },
                                        },
                                        [_vm._v("恢复默认")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("a-button", { attrs: { icon: "setting" } }, [
                        _vm._v("列设置"),
                      ]),
                    ],
                    2
                  ),
                  _c(
                    "a-tooltip",
                    {
                      attrs: {
                        slot: "action",
                        placement: "left",
                        title:
                          "销售出库单可以由销售订单转过来，也可以单独创建。\n        销售出库单据中的仓库列表只显示当前用户有权限的仓库。销售出库单可以使用多账户收款。\n        勾选单据之后可以进行批量操作（删除、审核、反审核）",
                      },
                      slot: "action",
                    },
                    [
                      _vm.btnEnableList.indexOf(1) > -1
                        ? _c("a-icon", {
                            staticStyle: {
                              "font-size": "20px",
                              float: "right",
                            },
                            attrs: { type: "question-circle" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("a-table", {
                    ref: "table",
                    attrs: {
                      size: "middle",
                      bordered: "",
                      rowKey: "id",
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      components: _vm.handleDrag(_vm.columns),
                      pagination: _vm.ipagination,
                      scroll: _vm.scroll,
                      loading: _vm.loading,
                      rowSelection: {
                        selectedRowKeys: _vm.selectedRowKeys,
                        onChange: _vm.onSelectChange,
                      },
                      expandedRowKeys: _vm.expandedRowKeys,
                    },
                    on: { expand: _vm.onExpand, change: _vm.handleTableChange },
                    scopedSlots: _vm._u([
                      {
                        key: "action",
                        fn: function (text, record) {
                          return _c(
                            "span",
                            {},
                            [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.myHandleDetail(
                                        record,
                                        "销售出库",
                                        _vm.prefixNo
                                      )
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              ),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  })
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.myHandleEdit(record)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  )
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  })
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.myHandleCopyAdd(record)
                                        },
                                      },
                                    },
                                    [_vm._v("复制")]
                                  )
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c("a-divider", {
                                    attrs: { type: "vertical" },
                                  })
                                : _vm._e(),
                              _vm.btnEnableList.indexOf(1) > -1
                                ? _c(
                                    "a-popconfirm",
                                    {
                                      attrs: { title: "确定删除吗?" },
                                      on: {
                                        confirm: () =>
                                          _vm.myHandleDelete(record),
                                      },
                                    },
                                    [_c("a", [_vm._v("删除")])]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        },
                      },
                      {
                        key: "customRenderDebt",
                        fn: function (value, record) {
                          return [
                            _c("a-tooltip", { attrs: { title: "有收款单" } }, [
                              value > 0 && value > record.lastDebt
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "green" } },
                                    [_vm._v(_vm._s(value))]
                                  )
                                : _vm._e(),
                            ]),
                            _c("a-tooltip", { attrs: { title: "暂未收款" } }, [
                              value > 0 && value === record.lastDebt
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [_vm._v(_vm._s(value))]
                                  )
                                : _vm._e(),
                            ]),
                            value === 0
                              ? _c("span", [_vm._v(_vm._s(value))])
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "customRenderStatus",
                        fn: function (status) {
                          return [
                            status == "0"
                              ? _c("a-tag", { attrs: { color: "red" } }, [
                                  _vm._v("未审核"),
                                ])
                              : _vm._e(),
                            status == "1"
                              ? _c("a-tag", { attrs: { color: "green" } }, [
                                  _vm._v("已审核"),
                                ])
                              : _vm._e(),
                            status == "2"
                              ? _c("a-tag", { attrs: { color: "cyan" } }, [
                                  _vm._v("完成出库"),
                                ])
                              : _vm._e(),
                            status == "3"
                              ? _c("a-tag", { attrs: { color: "blue" } }, [
                                  _vm._v("部分出库"),
                                ])
                              : _vm._e(),
                            status == "9"
                              ? _c("a-tag", { attrs: { color: "orange" } }, [
                                  _vm._v("审核中"),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "expandedRowRender",
                        fn: function (record) {
                          return _c("a-table", {
                            attrs: {
                              bordered: "",
                              size: "small",
                              loading: record.loading,
                              columns: _vm.detailColumns,
                              dataSource: record.childrens,
                              "row-key": (record) => record.id,
                              pagination: false,
                            },
                          })
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("sale-out-modal", {
                ref: "modalForm",
                on: { ok: _vm.modalFormOk, close: _vm.modalFormClose },
              }),
              _c("sale-back-modal", {
                ref: "transferModalForm",
                on: { ok: _vm.modalFormOk, close: _vm.modalFormClose },
              }),
              _c("bill-detail", {
                ref: "modalDetail",
                on: { ok: _vm.modalFormOk, close: _vm.modalFormClose },
              }),
              _c("bill-excel-iframe", {
                ref: "billExcelIframe",
                on: { ok: _vm.modalFormOk, close: _vm.modalFormClose },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }